import { render, staticRenderFns } from "./prd_attrib.vue?vue&type=template&id=0bb6d0e6&scoped=true&"
import script from "./prd_attrib.vue?vue&type=script&lang=js&"
export * from "./prd_attrib.vue?vue&type=script&lang=js&"
import style0 from "./prd_attrib.vue?vue&type=style&index=0&id=0bb6d0e6&scoped=true&lang=less&"
import style1 from "./prd_attrib.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb6d0e6",
  null
  
)

export default component.exports